import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { IntegrationSystem } from '@/shared/types';

import { createSystemRoutes, RoutesBySystem } from '@/router/utils';

import { RMP_ROUTES } from './config';

const MissingPersonExtract = lazy(() => import('../pages/services/MissingPersonExtract'));
const MissingPerson = lazy(() => import('../pages/services/MissingPerson'));

const rmpSystemComponents: Record<
  keyof RoutesBySystem<IntegrationSystem.RMP>,
  React.LazyExoticComponent<React.FC<any>>
> = {
  MISSING_PERSON: MissingPerson,
  MISSING_PERSON_EXTRACT: MissingPersonExtract,
};

export const RmpRouter: RouteObject = createSystemRoutes(IntegrationSystem.RMP, RMP_ROUTES, rmpSystemComponents);
